import type { EnhancedSmartLink } from '../utils/smartLinkTypes.ts';

import { createPanelDataBridge, type PanelDataBridge } from './createPanelDataBridge.ts';

export type OutgoingLinksBridgeData = {
	contentId: string | undefined;
	outgoingLinks: EnhancedSmartLink[];
};

export const initialOutgoingLinksBridgeData: OutgoingLinksBridgeData = {
	contentId: undefined,
	outgoingLinks: [],
};

type OutgoingLinksBridge = PanelDataBridge<OutgoingLinksBridgeData>;

/**
 * Carries the content-scoped outgoing links collected by the byline to the panel.
 *
 * Only ever written from an effect, so nothing publishes during SSR and this
 * module-level state cannot leak between server requests.
 */
const outgoingLinksBridge: OutgoingLinksBridge = createPanelDataBridge(
	initialOutgoingLinksBridgeData,
);

// Annotated because `isolatedDeclarations` cannot infer a re-exported binding.
export const publishOutgoingLinks: OutgoingLinksBridge['publish'] = outgoingLinksBridge.publish;
export const clearOutgoingLinks: OutgoingLinksBridge['clear'] = outgoingLinksBridge.clear;
export const subscribeToOutgoingLinks: OutgoingLinksBridge['subscribe'] =
	outgoingLinksBridge.subscribe;
export const useOutgoingLinks: OutgoingLinksBridge['useValue'] = outgoingLinksBridge.useValue;
export const clearOutgoingLinksForTesting: OutgoingLinksBridge['clearForTesting'] =
	outgoingLinksBridge.clearForTesting;
